export default __webpack_public_path__ + "static/media/Copy of with-change-comes-compliance.6f59986b.jpg";